import 'core-js/es/object/assign';
import defaultsDeep from 'lodash/defaultsDeep';
import debounce from 'lodash/debounce';
import Swiper from 'swiper/swiper-bundle.esm.browser.min.js';

class Slider {
    constructor($slider, options) {
        if (!$slider)
            return;

        const defaults = {
            focusable: null, // selektor dziecka, ktore ma miec focus lub null jesli caly slajd
            init: false,
            watchOverflow: true,
            keyboard: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            a11y: {
                'prevSlideMessage': 'Przejdź do poprzedniego slajdu',
                'nextSlideMessage': 'Przejdź do następnego slajdu',
                'firstSlideMessage': 'To jest pierwszy slajd',
                'lastSlideMessage': 'To jest ostatni slajd',
                'paginationBulletMessage': 'Idź do slajdu numer {{index}}'
            },
            on: {
                transitionStart: this.markVisible.bind(this)
            },
            // wrapperClass: 'slides',
            // slideClass: 'slide'
        };

        this.params = defaultsDeep(options, defaults);

        this.$slider = $slider;

        this.init();
        this.resize();

        window.addEventListener('resize', debounce(this.resize.bind(this), 300));
        window.addEventListener('load', this.forceResize.bind(this), false);
        this.$slider.addEventListener('focusin', this.handleFocus.bind(this));
    }

    forceResize() {
        let event = document.createEvent('HTMLEvents');

        event.initEvent('resize', true, false);
        document.dispatchEvent(event);
    }

    init() {
        if (this.params.navigation === true) {
            let id = this.$slider.dataset && this.$slider.dataset.id ? this.$slider.dataset.id : this.$slider.id;

            this.params.navigation = {
                nextEl: '.arrow-next',
                prevEl: '.arrow-prev',
            };

            this.$slider.insertAdjacentHTML('afterbegin', `<div class="slider-navigation hidden">
                <button class="arrow-prev" aria-controls="${id}"></button>
                <button class="arrow-next" aria-controls="${id}"></button>
            </div>`);
        }
        if (this.params.navigation) {
            this.$nav = this.$slider.querySelector('.slider-navigation');
        }
    }

    markVisible() {
        let lastVisible, firstVisible;

        if (this.slider.isEnd) {
            lastVisible = this.slider.slides.length;
            firstVisible = lastVisible - this.visibleCount;
        } else {
            lastVisible = this.slider.activeIndex + this.visibleCount - 1;
            firstVisible = this.slider.activeIndex;
        }

        let slidesArr = Array.from(this.slider.slides);
        slidesArr.forEach((el, i) => {
            if (i < firstVisible || i > lastVisible) {
                el.classList.remove('slide-visible');
            } else {
                el.classList.add('slide-visible');
            }
        });

        this.setLock(!this.isSlideFocused);
    }

    resize() {
        this.setVisibleCount();

        if (this.visibleCount === 0 && this.slider) {
            this.slider.destroy();
            this.slider = null;
            if (this.$nav) this.$nav.classList.add('hidden');
        } else if (this.visibleCount !== 0 && !this.slider) {
            this.slider = new Swiper(this.$slider, this.params);
            this.slider.init();
            this.markVisible();
            if (this.$nav) this.$nav.classList.remove('hidden');
        }
    }

    setVisibleCount() {
        let windowWidth = document.documentElement.clientWidth;
        this.visibleCount = this.params.slidesPerView;

        if (this.params.breakpoints) {
            for (let b in this.params.breakpoints) {
                if (this.params.breakpoints.hasOwnProperty(b) && b <= windowWidth) {
                    if (this.params.breakpoints[b].disable) {
                        this.visibleCount = 0;
                    } else {
                        this.visibleCount = this.params.breakpoints[b].slidesPerView;
                    }
                }
            }
        }

        this.visibleCount = Math.floor(this.visibleCount);
    }

    setLock(doSetLock) {
        let slidesArr = Array.from(this.slider.slides);

        slidesArr.forEach(($el, i) => {
            let $mainFocusable = this.params.focusable ? $el.querySelector(this.params.focusable) : $el,
                $focusableElems, state;

            if (!$mainFocusable) {
                return;
            }

            $focusableElems = $mainFocusable.querySelectorAll('[tabindex], [href]');
            state = doSetLock ? ($el.classList.contains('slide-visible') ? '0' : '-1') : '0';

            $mainFocusable.setAttribute('tabindex', state);
            for (let $el of $focusableElems) {
                $el.setAttribute('tabindex', '-1');
            }
        });
    }

    handleFocus(e) {
        if (e.target.classList.contains('events-slider-map-link')) return;

        let $slide = e.target.closest('.swiper-slide');

        if (!$slide) {
            this.isSlideFocused = false;
            return;
        }

        let idx = [...$slide.parentNode.children].indexOf($slide);

        this.slider.slideTo(idx);

        this.isSlideFocused = true;
        this.setLock(false);
        this.$slider.scrollLeft = 0;

        for (let $el of $slide.querySelectorAll('[tabindex], [href]')) {
            $el.setAttribute('tabindex', '0');
        }
    }
}

export default Slider;
